import {
    createBrowserRouter,
    RouterProvider,
    Outlet,
} from "react-router-dom";
import { routes } from "./routes";

const router = createBrowserRouter([
    {
        path: "",
        element: <Outlet />, // if we need a layout it's here
        children: routes,
    },
]);

export default function Router() {
    return(
        <RouterProvider router={router} />
    )
}
